export default {
  title: 'My Meta Id Selection',
  txt1: 'You have obtained new ID numbers through other activities, and the newly obtained ID numbers will be reserved for you for 14 days. Quickly choose 1 of them as your exclusive ID number!',
  btnTxt1: 'Use this ID Number',
  card1:
    'Obtained from the "Digital Intelligence World of 5 Million Users" activity',
  card2: 'Obtained from entering the MyLink Metaverse',
  card3: 'Date of entry',
  popupTxt1: 'Are you sure to use this ID number?',
  popupTxt2:
    'The ID number you choose will be your exclusive ID in the MyLink Metaverse. Are you sure you want to continue?',
  popupTxt3: 'Confirm',
  popupTxt4: 'Think Again',
  isNewLabel:
    'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/identity/identity/New_acquisition_en.png',
  isUseLabel:
    'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/identity/identity/using_en.png',
  toastTxt1: 'ID number changed successfully',
  toastTxt2: 'No network available, please try again'
}
